/**
 * Coach Grenade — chat virtual + control de acceso + memoria persistente
 */
(function () {
  'use strict';

  var cfg = window.MG_COACH || {};
  if (!cfg.enabled) return;

  var historyLoaded = false;

  function resolveSessionId() {
    if (window.MG_CUSTOMER && window.MG_CUSTOMER.id) {
      var key = 'mg-coach-cust-' + window.MG_CUSTOMER.id;
      localStorage.setItem('mg-coach-session', key);
      return key;
    }
    var guest = localStorage.getItem('mg-coach-session');
    if (!guest) {
      guest = 'mg-guest-' + Date.now();
      localStorage.setItem('mg-coach-session', guest);
    }
    return guest;
  }

  var sessionId = resolveSessionId();

  function hasAccess() {
    if (cfg.active) return true;
    try {
      var until = localStorage.getItem('mg-coach-until');
      if (until && new Date(until) > new Date()) return true;
    } catch (e) {}
    return false;
  }

  function syncLocalAccess() {
    if (cfg.active && cfg.expiresAt) {
      localStorage.setItem('mg-coach-until', cfg.expiresAt);
    }
  }

  function profile() {
    var p = {};
    if (window.MGProfilePrefs && window.MGProfilePrefs.toFinderAnswers) {
      p = window.MGProfilePrefs.toFinderAnswers() || {};
    }
    if (window.MG_CUSTOMER) {
      if (window.MG_CUSTOMER.firstName) p.firstName = window.MG_CUSTOMER.firstName;
      if (window.MG_CUSTOMER.lastName) p.lastName = window.MG_CUSTOMER.lastName;
      if (window.MG_CUSTOMER.email) p.email = window.MG_CUSTOMER.email;
    }
    return p;
  }

  function pageContext() {
    var p = {};
    if (window.MG_PRODUCT) {
      p.product_handle = window.MG_PRODUCT.handle;
      p.product_title = window.MG_PRODUCT.title;
    }
    return p;
  }

  function el(sel, root) {
    return (root || document).querySelector(sel);
  }

  function formatCoachText(text) {
    var safe = String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    return safe
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/_(.+?)_/g, '<em>$1</em>')
      .replace(/^\* (.+)$/gm, '• $1')
      .replace(/^- (.+)$/gm, '• $1')
      .replace(/\n/g, '<br>');
  }

  var typingEl = null;

  function showTyping(on) {
    var box = el('[data-mg-coach-messages]');
    if (!box) return;
    if (on) {
      if (typingEl) return;
      typingEl = document.createElement('div');
      typingEl.className = 'mg-coach-msg mg-coach-msg--bot mg-coach-msg--typing';
      typingEl.innerHTML = '<span class="mg-coach-typing-dots"></span> Coach escribiendo…';
      box.appendChild(typingEl);
      box.scrollTop = box.scrollHeight;
    } else if (typingEl) {
      typingEl.remove();
      typingEl = null;
    }
  }

  function addMessage(text, role, products, opts) {
    opts = opts || {};
    var box = el('[data-mg-coach-messages]');
    if (!box) return;
    var div = document.createElement('div');
    div.className = 'mg-coach-msg mg-coach-msg--' + (role === 'user' ? 'user' : 'bot');
    if (role === 'user') {
      div.textContent = text;
    } else {
      div.innerHTML = formatCoachText(text);
    }
    if (products && products.length) {
      var wrap = document.createElement('div');
      wrap.className = 'mg-coach-msg__products';
      products.forEach(function (pr) {
        var a = document.createElement('a');
        a.className = 'mg-coach-msg__product';
        a.href = pr.url || '/products/' + pr.handle;
        a.textContent = (pr.title || pr.handle) + (pr.price_clp ? ' — $' + pr.price_clp.toLocaleString('es-CL') : '');
        a.target = '_blank';
        wrap.appendChild(a);
      });
      div.appendChild(wrap);
    }
    if (opts.restored) div.setAttribute('data-mg-coach-restored', '1');
    box.appendChild(div);
    if (!opts.silent) box.scrollTop = box.scrollHeight;
  }

  function setLoading(on) {
    var btn = el('[data-mg-coach-send]');
    var input = el('[data-mg-coach-input]');
    if (btn) btn.disabled = on;
    if (input) input.disabled = on;
  }

  function apiUrl(path) {
    var base = (cfg.apiUrl || '').replace(/\/$/, '');
    if (!base) return '';
    return base + path;
  }

  function sessionQuery() {
    var q = 'sessionId=' + encodeURIComponent(sessionId);
    if (window.MG_CUSTOMER && window.MG_CUSTOMER.id) {
      q += '&customerId=' + encodeURIComponent(window.MG_CUSTOMER.id);
    }
    if (window.MG_CUSTOMER && window.MG_CUSTOMER.email) {
      q += '&email=' + encodeURIComponent(window.MG_CUSTOMER.email);
    }
    return q;
  }

  function loadSavedHistory() {
    if (historyLoaded || !hasAccess()) return Promise.resolve();
    var url = apiUrl('/session?' + sessionQuery());
    if (!url) return Promise.resolve();

    return fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        historyLoaded = true;
        if (data.sessionId) {
          sessionId = data.sessionId;
          localStorage.setItem('mg-coach-session', sessionId);
        }
        var box = el('[data-mg-coach-messages]');
        if (!box || !data.messages || !data.messages.length) return;

        box.innerHTML = '';
        data.messages.forEach(function (m) {
          addMessage(m.text, m.role === 'user' ? 'user' : 'bot', m.products, { restored: true, silent: true });
        });
        box.scrollTop = box.scrollHeight;
      })
      .catch(function () {
        historyLoaded = true;
      });
  }

  function showWelcomeIfEmpty() {
    var box = el('[data-mg-coach-messages]');
    if (!box || box.children.length) return;
    var welcome = document.createElement('div');
    welcome.className = 'mg-coach-msg mg-coach-msg--bot';
    welcome.setAttribute('data-mg-coach-welcomed', '1');
    var name = (window.MG_CUSTOMER && window.MG_CUSTOMER.firstName) || 'atleta';
      welcome.textContent =
        '¡Hola ' + name + '! Soy Coach Grenade 🏋️\n\nRecuerdo nuestras charlas. Pregúntame por rutina, técnica, nutrición o lo que necesites para progresar.';
    box.appendChild(welcome);
  }

  function sendMessage(text, attempt) {
    attempt = attempt || 0;
    var url = apiUrl('/chat');
    if (!url) {
      addMessage(
        'Coach en modo demo. Configura la URL API en Temas → Coach Grenade.\n\nMientras tanto: escríbenos por WhatsApp al +56 9 9801 4468.',
        'bot'
      );
      return Promise.resolve();
    }

    var controller = new AbortController();
    var timer = setTimeout(function () {
      controller.abort();
    }, 90000);

    showTyping(true);

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      signal: controller.signal,
      body: JSON.stringify({
        sessionId: sessionId,
        message: text,
        profile: profile(),
        page: pageContext(),
        customerId: window.MG_CUSTOMER && window.MG_CUSTOMER.id,
        email: window.MG_CUSTOMER && window.MG_CUSTOMER.email,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.error) throw new Error(data.error);
        if (data.sessionId) {
          sessionId = data.sessionId;
          localStorage.setItem('mg-coach-session', sessionId);
        }
        showTyping(false);
        addMessage(data.reply || 'Sin respuesta.', 'bot', data.products);
        if (data.follow_up && data.follow_up.length > 6) {
          setTimeout(function () {
            addMessage(data.follow_up, 'bot');
          }, 500);
        }
      })
      .catch(function (err) {
        showTyping(false);
        if (attempt < 1) {
          return sendMessage(text, attempt + 1);
        }
        throw err;
      })
      .finally(function () {
        clearTimeout(timer);
      });
  }

  function openPanel() {
    var panel = el('[data-mg-coach-panel]');
    if (!panel) return;
    panel.classList.add('is-open');
    document.body.classList.add('mg-coach-open');
    loadSavedHistory().then(showWelcomeIfEmpty);
    var input = el('[data-mg-coach-input]');
    if (input) setTimeout(function () { input.focus(); }, 300);
  }

  function closePanel() {
    var panel = el('[data-mg-coach-panel]');
    if (panel) panel.classList.remove('is-open');
    document.body.classList.remove('mg-coach-open');
  }

  function unlockPanelIfNeeded(panel) {
    if (!hasAccess() || el('[data-mg-coach-form]')) return;
    var locked = panel.querySelector('.mg-coach-panel__locked');
    if (!locked) return;
    locked.remove();
    var status = panel.querySelector('.mg-coach-panel__status');
    if (status) {
      status.textContent =
        'Activo · ' + (cfg.daysLeft || '?') + ' día' + (cfg.daysLeft === 1 ? '' : 's') + ' restantes';
      status.style.color = '';
    }
    var messages = document.createElement('div');
    messages.className = 'mg-coach-panel__messages';
    messages.setAttribute('data-mg-coach-messages', '');
    var form = document.createElement('form');
    form.className = 'mg-coach-panel__form';
    form.setAttribute('data-mg-coach-form', '');
    form.innerHTML =
      '<input type="text" class="mg-coach-panel__input" data-mg-coach-input placeholder="Ej: rutina para definir, stack con proteína..." maxlength="500" autocomplete="off">' +
      '<button type="submit" class="mg-coach-panel__send" data-mg-coach-send>Enviar</button>';
    panel.appendChild(messages);
    panel.appendChild(form);
  }

  function initWidget() {
    syncLocalAccess();
    var fab = el('[data-mg-coach-fab]');
    var panel = el('[data-mg-coach-panel]');
    if (!fab || !panel) return;

    unlockPanelIfNeeded(panel);

    if (hasAccess()) {
      loadSavedHistory().then(showWelcomeIfEmpty);
    }

    fab.addEventListener('click', function () {
      if (panel.classList.contains('is-open')) closePanel();
      else openPanel();
    });

    var closeBtn = el('[data-mg-coach-close]');
    if (closeBtn) closeBtn.addEventListener('click', closePanel);

    var form = el('[data-mg-coach-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!hasAccess()) return;
        var input = el('[data-mg-coach-input]');
        var text = (input && input.value || '').trim();
        if (!text) return;
        input.value = '';
        addMessage(text, 'user');
        setLoading(true);
        sendMessage(text)
          .catch(function (err) {
            addMessage('No pude conectar con Coach Grenade. Intenta en unos segundos o por WhatsApp.', 'bot');
            console.warn('MG Coach:', err);
          })
          .finally(function () {
            setLoading(false);
          });
      });
    }

    if (window.location.search.indexOf('coach=open') >= 0 && hasAccess()) {
      openPanel();
    }
  }

  document.addEventListener('DOMContentLoaded', initWidget);
  window.MGCoach = { open: openPanel, close: closePanel, hasAccess: hasAccess };
})();